/* cookies.ts */

/* Cookies */
import Cookies from "js-cookie";

/* Axios */
import { AxiosResponse } from "axios";

/* Interfaces */
import { TokenResponse } from "src/shared/interfaces/api/Token";
import { AuthProps } from "src/shared/interfaces/common/Auth";

export const computeExpirationTime = (time: number) => {
  return Date.now() + time * 1000;
};

export const convertSecondsToDays = (
  days: number
): number => {
  const secondsPerDay = 86400;
  return days / secondsPerDay;
};

export const createCookies = (
  response: AxiosResponse<TokenResponse>
): AuthProps => {
  Cookies.set("access_token", response.data.access_token, {
    expires: convertSecondsToDays(response.data.expires_in),
  });
  Cookies.set(
    "refresh_token",
    response.data.refresh_token,
    {
      expires: convertSecondsToDays(
        response.data.refresh_expires_in
      ),
    }
  );

  return {
    isAuthenticated: true,
    expirationTime: computeExpirationTime(
      response.data.expires_in
    ),
  };
};
